import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { StyleManagerService } from './core/services/style-manager.service';
import { PrimeNGConfig } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: [ './app.component.scss' ]
})
export class AppComponent implements OnInit {

    public defaultTheme: string = 'icai';
    public title       : string = 'Inscripciones ICAI-ICADE';

    public constructor (
        private titleService: Title,
        private styleManagerService: StyleManagerService,
        private primeNgConfig: PrimeNGConfig,
        private translateService: TranslateService) { }

    ngOnInit () {

        this.setWebTitle();
        this.setWebIcon();
        this.setWebTheme(this.defaultTheme);
        this.setLanguage();

    }

    private setWebTitle () {

        this.titleService.setTitle(this.title);

    }

    private setWebIcon () {

        var campusIcon = 'assets/favicon.ico';

        const favIcon: HTMLLinkElement = document.querySelector('#appIcon') as HTMLLinkElement;
        favIcon.href = campusIcon;

    }

    private setWebTheme(themeName: string) {

        this.styleManagerService.setStyle("theme", `${themeName}.css`);

    }

    private setLanguage () {

        const currentLanguage = 'es';
        this.translateService.setDefaultLang(currentLanguage);
        this.translate(currentLanguage);

    }

    private translate (language: string) {

        this.translateService.use(language);
        this.translateService.get('primeng').subscribe(res => this.primeNgConfig.setTranslation(res));

    }

}
